import {IStateStore} from '../../ap-interface/interfaces/store';
import {Injectable}  from '@angular/core';
import {Store}       from '../index';
import {
  ApCustomTypes,
  NetTypes,
  SoilSamplePlanningReportDownload,
  SoilSamplePlanningReportDownloadSuccess
}                    from 'invoker-transport';
import * as download from 'downloadjs';
import IReportData = Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IReportData;
import {ApSignalrService} from '../../ap-core/services/ap-signalr.service';

interface ISoilSamplePlanningReportStore extends IStateStore<string> {
}

@Injectable({providedIn: 'root'})
export class SoilSamplePlanningReportStore extends Store<ISoilSamplePlanningReportStore> {
  constructor(public backend: ApSignalrService) {
    super(backend, {
      data: [],
      loaded: false,
      loading: false
    });

    backend.registerObservable(SoilSamplePlanningReportDownloadSuccess).subscribe(d => {
      super.SetLoadFinishState();
      download(d.Data[1], d.Data[0], 'application/excel');
    });
  }

  public downloadSoilSamplePlanningReport(headline: string, bookname: string, reportData: IReportData): void {
    super.SetLoadState();
    super.Mutate(s => s.data, () => []);
    this.DispatchBackend(new SoilSamplePlanningReportDownload([
      {Name: 'headline', Type: NetTypes.STRING, Value: headline},
      {Name: 'bookName', Type: NetTypes.STRING, Value: bookname},
      {
        Name: 'reportData',
        Type: ApCustomTypes.Agriport_Excel_Factory_InputData_SoilSamplePlanningReport_ReportData,
        Value: reportData
      }
    ]));
  }
}
